import { FC, SVGProps } from "react";

const Burger: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" stroke="currentcolor" strokeWidth={2} strokeLinecap="round" {...props}>
      <path d="M4 18L20 18"/>
      <path d="M4 12L20 12" />
      <path d="M4 6L20 6"/>
    </svg>
  );
};

export default Burger;
